import type { TypedString } from 'types/TypedString';

type Props = {
  videoId: TypedString<'vimeo-video-id'>;
  autoPlay: boolean | undefined;
  muted: boolean | undefined;
};

export function getVimeoVideoSrc({ videoId, autoPlay, muted }: Props): string {
  const options = [
    'api=1',
    autoPlay && 'autoplay=1',
    muted && 'background=1',
  ].filter(Boolean);

  return `https://player.vimeo.com/video/${videoId}?${options.join('&')}`;
}
